import { type PropsWithChildren } from 'react';

import { ErrorPage } from '@/components/ErrorPage';
import { LoaderFull } from '@/components/LoaderFull';
import { useGetCandidateQuery } from '@/features/interview';

import { useCoachCredential } from './useCoachCredential';

export const GuardCoachInterview: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { candidateId, token } = useCoachCredential();

  const candidate = useGetCandidateQuery(
    {
      candidateId: candidateId!,
      token: token!,
    },
    {
      enabled: !!candidateId && !!token,
    }
  );

  if (!candidateId || !token || candidate.isError) {
    return <ErrorPage errorCode={candidate.error?.response?.status} />;
  }

  if (candidate.data) return children;

  return <LoaderFull />;
};
